export enum Conjunction {
  And = 'AND',
  Or = 'OR',
}
